function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgCube(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M19.781 9.584a.408.408 0 01.56.378v7.482a.773.773 0 01-.46.692l-6.37 2.83a.406.406 0 01-.57-.372v-7.841a.655.655 0 01.417-.613zm-15.905.062a.408.408 0 01.377-.043l6.425 2.537a.66.66 0 01.418.608v7.842a.408.408 0 01-.572.37l-6.365-2.838a.77.77 0 01-.462-.692V9.98c.001-.133.068-.259.179-.334zm6.546-6.615a.362.362 0 01.509.331v3.031A8.696 8.696 0 006.375 8.4L2.891 7.025a.36.36 0 010-.666zm2.865.04a.36.36 0 01.344-.027l7.5 3.315a.363.363 0 01-.013.656L17.668 8.4a8.703 8.703 0 00-4.543-1.994V3.375a.36.36 0 01.162-.304z"
  }));
}

SvgCube.clsName = 'icon-www__cube';
SvgCube.remarkName = 'unknown';
export default SvgCube;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Cube.js
// module id = 2327
// module chunks = 17 18